import {
  BatchStatisticsConditionListItem,
  BatchStatisticsConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsConditionListItem'

export interface BatchStatisticsGetPredefinedSettingResult {
  items: BatchStatisticsConditionListItem
}

export function BatchStatisticsGetPredefinedSettingResultFromJSON(
  json: any
): BatchStatisticsGetPredefinedSettingResult {
  return {
    items: BatchStatisticsConditionListItemFromJSON(json)
  }
}
